<ng-container *ngIf="!isSent">
  <span class="text-grisMedio3">{{ completedExcercises }}/</span><span class="text-grisMedio3 font-bold">{{ totalExcercises }}</span>
</ng-container>
<ng-container *ngIf="isSent">
  <div class="activity-tag">Entregada</div>
</ng-container>
